import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import {
  getSupplierById,
  updateSupplier,
} from '../../services/firestoreService';
import SupplierForm from './SupplierForm';

export default function SupplierEdit() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [supplier, setSupplier] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const fetchSupplier = async () => {
      try {
        const supplierData = await getSupplierById(id);
        setSupplier(supplierData);
      } catch (error) {
        console.error('Failed to load supplier:', error);
        setErrorMessage('Failed to load supplier.');
      }
    };

    fetchSupplier();
  }, [id]);

  const handleSubmit = async (data) => {
    if (!data.companyName) {
      setErrorMessage('Company Name is required.');
      return;
    }

    setErrorMessage('');
    setIsSubmitting(true);

    try {
      await updateSupplier(id, data);
      navigate(`/supplier/${id}`);
    } catch (error) {
      console.error(error);
      setErrorMessage('Update failed.');
      setIsSubmitting(false);
    }
  };

  if (!supplier && !errorMessage) {
    return <p>Loading supplier...</p>;
  }

  return (
    <SupplierForm
      initialData={supplier}
      onSubmit={handleSubmit}
      submitLabel={isSubmitting ? 'Saving...' : 'Save Supplier'}
      isSubmitting={isSubmitting}
      errorMessage={errorMessage}
      title="Edit Supplier"
    />
  );
}
